const documentos = {
  "204": {
    titulo: "Apoyo económico a personas artesanas, para acceder a capacitación técnica con la finalidad de fortalecer el mejoramiento de la condición productiva artesanal 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://sebiso.hidalgo.gob.mx/docs/convocatorias/Capacitacionartesanos2026.pdf"
      }
    ]
  }, 

  "203": {
    titulo: "18.ª EDICIÓN DEL CONCURSO REGIONAL DE BORDADOS Y TEXTILES DE LA REGIÓN OTOMÍ-TEPEHUA 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://sebiso.hidalgo.gob.mx/docs/convocatorias/Bordadosot2026.pdf"
      }
    ]
  }, 

 
  "202": {
    titulo: "13.ª EDICIÓN DEL CONCURSO REGIONAL DE ARTESANÍAS DE LA HUASTECA HIDALGUENSE 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://sebiso.hidalgo.gob.mx/docs/convocatorias/Artesaniashh2026.pdf"
      }
    ]
  }, 

 
  "201": {
    titulo: "9.ª EDICIÓN DEL CONCURSO REGIONAL DE ARTESANÍAS DEL VALLE DEL MEZQUITAL 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://sebiso.hidalgo.gob.mx/docs/convocatorias/Artesaniasvm2026.pdf"
      }
    ]
  }, 

  "90": {
    titulo: "Manual de Procedimientos para el Registro, Control y Seguimiento de Operaciones Financieras y Uso de Banca Digital",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Man_Proc_Reg_Op_FyB-Dig.pdf"
      }
    ]
  },

  "89": {
    titulo: "Lineamientos que Regulan el Mecanismo de Registro, Análisis y Atención Oportuna y Suficiente de las Quejas y Denuncias Presentadas a Través del Buzón y Correo Electrónico de la Secretaría de Bienestar e Inclusión Social",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Lineamientos_Atn_Quejas_Denuncias_SEBISO.pdf"
      }
    ]
  },  

  "88": {
    titulo: "Lineamientos de Elaboración de Manuales de Procesos",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Li_Manu_Proc.pdf"
      }
    ]
  },  
   
  
  "87": {
    titulo: "Lineaminetos para los Criterios de Calidad para la Correcta Formalización de la Documentación en la SEBISO",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Li_Form_Documentación_SEBISO.pdf"
      }
    ]
  },  

  "86": {
    titulo: "Políticas de Seguridad para los Sistemas Informáticos que se manejan en la Secretaría de Bienestar e Inclusión Social",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Pol_Seg_Sis_Inf_SBS.pdf"
      }
    ]
  },
  
  "85": {
    titulo: "Lineamientos de Comunicación Interna y Externa de la Secretaría de Bienestar e Inclusión Social",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/Lin_Com_IyEx_SBS.pdf"
      }
    ]
  },  
  
  "84": {
    titulo: "Informe de la Evaluación de Control Interno",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/INF_Ev_CI.pdf"
      }
    ]
  },  
  
  "83": {
    titulo: "Informe FODA de los Líneamientos de Comunicación Interna y Externa",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/FODA_CIyE.pdf"
      }
    ]
  }, 
  
  "82": {
    titulo: "Guía de Políticas Operativas 2025",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/G_PO_2025.pdf"
      }
    ]
  },
  
  "81": {
    titulo: "Diagnostico de Políticas Operativas de los Programas Sociales: Bienestar de Madres Trabajadoras y Apoyo Para el Bienestar y Desarrollo",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/DPOPS_MTyByD.pdf"
      }
    ]
  },
  "80": {
    titulo: "Estrategia de difusión del Código de Ética de la Administración Pública del Estado de Hidalgo y del Código de Conducta para los Servidores Públicos de la Secretaría de Bienestar e Inclusión Social (Antes SEDESO) a otras personas con las que se relaciona la Secretaría.",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/ESTRATEGIA_DIFUSIoN_CE_CC.pdf"
      }
    ]
  },

  "60": {
    titulo: "Acuerdo que crea el Comité de Control y Desempeño Institucional",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cocodi/Acuerdo_del_COCODI.pdf"
      }
    ]
  },

    "33": {
    titulo: "Invierte en Ti, Invierte en Hidalgo 2026 Segunda Edición",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/Convocatoria _Invierte_en_ti_invierte_en_Hidalgo_Septiembre_26.pdf"
      }
    ]
  },

   "32": {
    titulo: "Xantolo 2025",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2025/CONV_Xant_2025.pdf"
      }
    ]
  },

  "31": {
    titulo: "Apoyos Económicos Para Reconocer la Trayectoria de Personas Artesanas",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_PERSONAS_ARTESANAS.pdf"
      }
    ]
  },
  
  "30": {
    titulo: "Acuerdo que crea el Comité de Control y Desempeño Institucional",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cocodi/Acuerdo_del_COCODI.pdf"
      }
    ]
  },


  "29": {
    titulo: "Bienestar de Personas Cuidadoras de Personas con Discapacidad 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_CUIDADORES_2026.pdf"
      }
    ]
  },
  
  "28": {
    titulo: "Desarrollo Inclusivo 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_DESARROLLO_INCLUSIVO.pdf"
      }
    ]
  },

  "27": {
    titulo: "Apoyo para el Bienestar y Desarrollo 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_BIENESTAR_DESARROLLO_2026.pdf"
      }
    ]
  },

  "26": {
    titulo: "Bienestar de Madres Trabajadoras 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_MADRES_TRABAJADORAS_2026.pdf"
      }
    ]
  },

"25": {
    titulo: "Bienestar Para Personas Artesanas 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_PBPA_2026.pdf"
      }
    ]
  },

  "24": {
    titulo: "Programa Anual de Evaluación 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/pae/PAE_2026.pdf"
      }
    ]
  },

  "23": {
    titulo: "Encuesta CEPCI 2025",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2025/RESULTADOS_ENCUESTA_CEPCI_2025.pdf"
      }
    ]
  },

"22": {
    titulo: "Encuesta Código de Conducta 2025",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2025/RESULTADOS_ENCUESTA_C_DE_CONDUCTA_2025.pdf"
      }
    ]
  },
 
"21": {
    titulo: "Encuesta Código de Ética 2025",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2025/RESULTADOS_ENCUESTA_CÓDIGO_DE_ETICA_2025.pdf"
      }
    ]
  },

"20": {
    titulo: "Informe Anual de Actividades 2025",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2025/INFORME_ANUAL_CEPCI_2025_SEBISO.pdf"
      }
    ]
  },
  
  "19": {
    titulo: "Programa Anual de Trabajo 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2026/CEPCI_PROGRAMA_ANUAL_TRABAJO_2026.pdf"
      }
    ]
  },

   "18": {
    titulo: "Pronunciamiento Cero Tolerancia",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "UNIDAD INSTITUCIONAL PARA LA IGUALDAD ENTRE MUJERES Y HOMBRES",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/PRONUNCIAMIENTO_CERO_TOLERANCIA_2024.pdf"
      }
    ]
  },

   "17": {
    titulo: "Programa Anual de Trabajo 2025",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2025/Prog_Anual_Trab_2025.pdf"
      }
    ]
  },

  "16": {
    titulo: "Informe Anual de Actividades 2024",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Inf_Anuaal_Actividades_2024.pdf"
      }
    ]
  },

   "15": {
    titulo: "Encuesta CEPCI 2024",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Encuesta_EVC_CEPCI_2024.pdf"
      }
    ]
  },

  "14": {
    titulo: "Encuesta Código de Conducta 2024",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Encuesta_CC_2024.pdf"
      }
    ]
  },

   "13": {
    titulo: "Encuesta Código de Ética 2024",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Encuesta_CE_2024.pdf"
      }
    ]
  },


   "12": {
    titulo: "Atención a Personas Migrantes 2026",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CONVOCATORIA",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/conv/2026/CONVOCATORIA_MIGRANTES_2026.pdf"
      }
    ]
  },

   "11": {
    titulo: "Protocolo Cero",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "Protocolo Cero para la Prevención, Atención y Sanción del Acoso Sexual y/o Laboral en la Administración Pública del Estado de Hidalgo",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Protocolo_Cero.pdf"
      }
    ]
  },

  "10": {
    titulo: "Procedimiento y Protocolo Para la Recepción de Denuncias",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Proc_Prot_Rec_Atn_Denun..pdf"
      }
    ]
  },

  "9": {
    titulo: "Lineamientos Generales que Establecen las Bases Para la Integración, Organización y Funcionamiento de los Comités de Ética y Prevención de Conflictos de Interés",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Lineam_Prev_Conflictos.pdf"
      }
    ]
  },

   "8": {
    titulo: "Directorio del CEPCI",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2026/DIRECTORIO_CEPCI_2026.pdf"
      }
    ]
  },
  "7": {
    titulo: "Informe Anual de Actividades 2023",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Inf_Act_CEPCI_2023.pdf"
      }
    ]
  },

  "6": {
    titulo: "Programa Anual de Trabajo 2024",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Prog_Anual_Trab_2024.pdf"
      }
    ]
  },

  "5": {
    titulo: "Encuesta Código de Conducta 2023",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2024/Enc_Cod_Cond_2023.pdf"
      }
    ]
  },

  "4": {
    titulo: "Código de Ética de la Administración Pública del Estado de Hidalgo 2019",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/misc/Cod_Etica_Admon_Pub_Hgo.pdf"
      }
    ]
  },

   "3": {
    titulo: "Código de Conducta Para los Servidores Públicos de la Secretaría de Desarrollo Social del Estado de Hidalgo",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Cod_Conducta_SEDESO_2020.pdf"
      }
    ]
  },

  "2": {
    titulo: "Bases de Integración, Organización y Funcionamiento del Comité de Ética y Prevención de Conflictos de Interés",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Bases_de_Integracion.pdf"
      }
    ]
  },

  "1": {
    titulo: "Acuerdo mediante el cual se crea el CEPCI",
    background: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/BG_Wine.jpg",

    pdfs: [
      {
        id: 1,
        tituloTexto: "CEPCI",
        descripcion: "",
        tituloPdf: "",
        url: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Acuerdo_Creacion_Com_Etica.pdf"
      }
    ]
  },


};

export default documentos;